import { Component, OnInit } from "@angular/core";
import { Producto } from "../../../../model/class/Producto";
import {
  PUBLICADO,
  NO_PUBLICADO,
  DESCONTINUADO,
} from "../../../../model/interface/IProducto";
import { Archivo } from "../../../../model/class/Archivo";
import { FileUploader } from "ng2-file-upload";
import { APP_CONTS } from "../../../app.constants";
import { ImageResizeService } from "../../../services/image-resize.service";
import { DragulaService } from "ng2-dragula";
import * as _ from "lodash";
import { IColor } from "../../../../model/interface/IColor";
import { CertificacionesService } from "../../../services/certificaciones/certificaciones.service";
import { ICertificacion } from "../../../../model/interface/ICertificacion";
import { CategoriaService } from "../../../services/categoria/categoria.service";
import { Categoria } from "../../../../model/class/Categoria";
import { MarcaService } from "../../../services/marca/marca.service";
import { Marca } from "../../../../model/class/Marca";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operators";
import { ProductoService } from "../../../services/producto/producto.service";
import { forkJoin } from "rxjs/observable/forkJoin";
import { CategoriaProducto } from "../../../../model/class/CategoriaProducto";
import { ToastsManager } from "ng2-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmService } from "../../../services/confirm/confirm.service";
import { CategoriaDocumentosService } from "../../../services/categoria-documentos/categoria-documentos.service";
import { GeneralService } from "../../../services/general/general.service";
import { CategoriaDocumento } from "../../../../model/class/CategoriaDocumento";
import { Documento } from "../../../../model/class/Documento";
import { CodigoProducto } from "../../../../model/class/CodigoProducto";
import { CodigosProductoService } from "../../../services/codigos-prodicto/codigos-producto.service";
import { PreviewProductService } from "../../../services/preview-product/preview-product.service";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-crear-producto",
  templateUrl: "./crear-producto.component.html",
  styleUrls: ["./crear-producto.component.css"],
})
export class CrearProductoComponent implements OnInit {
  SF_URL = environment.SF_URL;
  TYPE_IMG_AVATAR = "PROD_IMAGEN_AVATAR";
  TYPE_IMG_GALLERY = "PROD_IMAGEN_GALERIA";
  TYPE_VIDEO_GALLERY = "PROD_VIDEO_GALERIA";
  TYPE_IMG_PRINCIPAL = "PROD_IMAGEN_PRINCIPAL";
  TYPE_DOCUMENT = "PROD_DOCUMENTO";
  tablaVertical = true;

  loaders = {
    guardar: false,
    eliminar: false,
    descontinuar: false,
    imagenes: false,
    galeria: false,
    prodComp: false,
    prodRel: false,
    prodAlt: false,
    search: false,
    preview: false,
  };

  product_slug = "";

  especialEstado: { hasEspecial: boolean; included: boolean; slug: string } = null;

  bags = {
    imagenes: "bag-imagenes",
    galeria: "bag-galeria",
  };

  dropZoneOver = {
    imagenes: false,
    galeria: false,
  };
  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;
  contIdsNuevos = -1;

  textoComp: string;
  textoRel: string;
  textoAlt: string;
  textoCompChanged: Subject<string> = new Subject<string>();
  textoRelChanged: Subject<string> = new Subject<string>();
  textoAltChanged: Subject<string> = new Subject<string>();
  prodCompBuscados: Producto[] = [];
  prodRelBuscados: Producto[] = [];
  prodAltBuscados: Producto[] = [];

  prodComplementarios: Producto[] = [];
  prodRelacionados: Producto[] = [];
  prodAlternativos: Producto[] = [];

  producto: Producto = new Producto({
    orden: 0,
    esPublicado: true,
    marcaId: 0,
  });
  marcas: Marca;

  codigosProducto: CodigoProducto[] = [];

  imagenesSeleccionadas: Archivo[] = [];
  imagenesBorradas: Archivo[] = [];

  imgGaleriaSeleccionadas: Archivo[] = [];
  imgGaleriaBorradas: Archivo[] = [];

  coloresSeleccionados: IColor[] = [];

  certificaciones: ICertificacion[];
  especificaciones: any[] = [
    {
      caracteristica: "",
      valor: "",
      otro: "",
    },
  ];

  newVideo: any;

  categoriasPadres: Categoria[] = [];
  catSeleccionadas = [
    {
      catPadreSel: undefined,
      catIntermediaSel: undefined,
      catHijaSel: undefined,
      loader: {
        intermedias: false,
        hijas: false,
      },
    },
  ];

  catDocumentos: CategoriaDocumento[] = [];
  catDocSeleccionadas = [
    {
      categoria: undefined,
      ficha: undefined,
      loader: {
        hijas: false,
      },
    },
  ];

  editando = false;
  idsCategoriasAntiguas: number[] = [];

  catDocParams: any = {
    filter: JSON.stringify([{ published: true }]),
  };

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();
  codigosBuscados: CodigoProducto[] = [];
  codigosEliminados: CodigoProducto[] = [];

  totalPorCargar = 9;
  totalCargados = 0;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType: APP_CONTS.FILES.CAT_ESP_FORMAT,
  });

  constructor(
    private _generalService: GeneralService,
    private dragulaService: DragulaService,
    private imageResizeService: ImageResizeService,
    private certificacionesService: CertificacionesService,
    private categoriaService: CategoriaService,
    private marcaService: MarcaService,
    private productoService: ProductoService,
    private toasts: ToastsManager,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmService: ConfirmService,
    private categoriaDocumentosService: CategoriaDocumentosService,
    private codigosProductoService: CodigosProductoService,
    private previewProductService: PreviewProductService
  ) {
    this.dragulaService.dropModel.subscribe((value) => {
      switch (value[0]) {
        case this.bags.imagenes: {
          this.emparejarOrden(this.bags.imagenes);
          break;
        }
        case this.bags.galeria: {
          this.emparejarOrden(this.bags.galeria);
          break;
        }
      }
    });

    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.editando = true;
        this.getProducto(Number(params.id));
      }
    });

    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoBuscar = model.toString();

        if (this.textoBuscar === "") {
          this.codigosBuscados = [];
        } else {
          this.buscarCodigo();
        }
      });

    this.textoCompChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoComp = model.toString();

        if (this.textoComp === "") {
          this.prodCompBuscados = [];
        } else {
          this.buscarProducto(this.textoComp, "complementarios");
        }
      });

    this.textoRelChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoRel = model.toString();

        if (this.textoRel === "") {
          this.prodRelBuscados = [];
        } else {
          this.buscarProducto(this.textoRel, "relacionados");
        }
      });

    this.textoAltChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoAlt = model.toString();

        if (this.textoAlt === "") {
          this.prodAltBuscados = [];
        } else {
          this.buscarProducto(this.textoAlt, "alternativos");
        }
      });
  }

  ngOnInit() {
    if (!this.editando) {
      this.certificacionesService.get().subscribe((data) => {
        this.certificaciones = data.data;
      });

      this.categoriaService.getPadres().subscribe((data) => {
        for (const o of data) {
          this.categoriasPadres.push(new Categoria(o));
        }
      });

      this.categoriaDocumentosService.gatAll(this.catDocParams).subscribe(
        (data) => {
          for (const iCatDoc of data.data) {
            this.catDocumentos.push(new CategoriaDocumento(iCatDoc));
          }
        },
        (error) => {}
      );
    }

    this.marcaService.all().subscribe((data) => {
      this.marcas = data.data;
    });
  }

  cargarEstadoEspecial() {
    if (!this.producto.marcaId || !this.producto.id) {
      return;
    }

    this._generalService
      .obtenerEstadoEspecialDeProducto(this.producto.marcaId, this.producto.id)
      .subscribe((estado) => {
        this.especialEstado = estado;
      });
  }

  stringToSlug(string) {
    const str = string
      .toLowerCase()
      .replace(/[\s+]/gi, "-")
      .replace("Ñ", "n")
      .replace(/[\[\]]/g, "")
      .replace(/[\%\(\)\.\/"+]/gi, "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[--]/g, "-");
    return str;
  }

  onTextoBuscarChange(texto: string) {
    this.loaders.search = true;
    this.textoBuscarChanged.next(texto);
  }

  limpiarTexto() {
    this.codigosBuscados = [];
    this.textoBuscar = "";
  }

  buscarCodigo() {
    let texto = this.textoBuscar.replace(new RegExp("span", "ig"), "");
    texto = _.trim(texto);

    if (texto) {
      const objetoBucar: any[] = [{ code: texto }];
      const parametros = { search: JSON.stringify(objetoBucar) };

      this.codigosBuscados = [];

      this.codigosProductoService
        .getNoAsignados(parametros)
        .subscribe((reap) => {
          const universoCodigos = reap.data;

          _.each(this.codigosEliminados, (codigo: CodigoProducto) => {
            const index = _.findIndex(universoCodigos, { id: codigo.id });
            if (index === -1) {
              universoCodigos.push(new CodigoProducto(codigo));
            }
          });

          _.each(universoCodigos, (codigo: CodigoProducto) => {
            const index = _.findIndex(this.codigosProducto, { id: codigo.id });
            if (index === -1) {
              this.codigosBuscados.push(new CodigoProducto(codigo));
            }
          });

          this.loaders.search = false;
        });
    } else {
      this.codigosBuscados = [];
      this.loaders.search = false;
    }
  }

  agregarCodigo(codigo: CodigoProducto) {
    this.codigosProducto.push(codigo);
    this.limpiarTexto();
  }

  borrarCodigo(codigo: CodigoProducto) {
    _.remove(this.codigosProducto, { id: codigo.id });
    this.codigosEliminados.push(codigo);
  }

  getProducto(idProduct: number) {
    this.limpiarPantalla();

    if (this.previewProductService.producto) {
      this.totalPorCargar = 2;
      this.totalCargados = 0;

      this.producto = this.previewProductService.producto;

      this.product_slug = this.stringToSlug(this.producto.nombre);

      this.especificaciones = this.producto.especificaciones.caracteristicas;
      this.tablaVertical = this.producto.especificaciones.esVertical;

      if (this.previewProductService.codigos) {
        this.codigosProducto = this.previewProductService.codigos;
      }
      if (this.previewProductService.colores) {
        this.coloresSeleccionados = this.previewProductService.colores;
      }
      if (this.previewProductService.categorias) {
        this.catSeleccionadas = this.previewProductService.categorias;
      }
      if (this.previewProductService.productosRelacionados) {
        this.prodRelacionados =
          this.previewProductService.productosRelacionados;
      }
      if (this.previewProductService.productosComplementarios) {
        this.prodComplementarios =
          this.previewProductService.productosComplementarios;
      }
      if (this.previewProductService.productosAlternativos) {
        this.prodAlternativos =
          this.previewProductService.productosAlternativos;
      }
      if (this.previewProductService.certificaciones) {
        this.certificaciones = this.previewProductService.certificaciones;
      }
      if (this.previewProductService.imagenesProducto) {
        this.imagenesSeleccionadas =
          this.previewProductService.imagenesProducto;
      }
      if (this.previewProductService.archivosGaleria) {
        this.imgGaleriaSeleccionadas =
          this.previewProductService.archivosGaleria;
      }
      if (this.previewProductService.archivosDescargables) {
        this.catDocSeleccionadas =
          this.previewProductService.archivosDescargables;
      }

      this.previewProductService.borrar();
      this.cargarEstadoEspecial();

      this.categoriaDocumentosService
        .gatAll(this.catDocParams)
        .subscribe((resp) => {
          this.totalCargados++;
          for (const iCatDoc of resp.data) {
            this.catDocumentos.push(new CategoriaDocumento(iCatDoc));
          }

          for (const iFicha of this.catDocSeleccionadas) {
            const padre = _.find(this.catDocumentos, {
              id: iFicha.categoria.id,
            });

            if (padre) {
              padre.fichasHijas = iFicha.categoria.fichasHijas;
              iFicha.categoria = padre;
            }
          }
        });

      this.categoriaService.getPadres().subscribe((resp) => {
        this.totalCargados++;
        for (const o of resp) {
          this.categoriasPadres.push(new Categoria(o));
        }

        for (const iCate of this.catSeleccionadas) {
          const padre = _.find(this.categoriasPadres, {
            id: iCate.catPadreSel.id,
          });

          if (padre) {
            padre.categoriasHijas = iCate.catPadreSel.categoriasHijas;
            iCate.catPadreSel = padre;
          }
        }
      });
    } else {
      this.productoService.get(idProduct).subscribe((data) => {
        this.totalCargados++;

        this.producto = new Producto(data);
        this.product_slug = this.stringToSlug(this.producto.nombre);

        if (!this.producto.marcaId) {
          this.producto.marcaId = 0;
        }

        this.cargarEstadoEspecial();

        this.especificaciones = [];
        if (this.producto.especificaciones) {
          if (this.producto.especificaciones.caracteristicas) {
            this.especificaciones =
              this.producto.especificaciones.caracteristicas;
          }

          this.tablaVertical = this.producto.especificaciones.esVertical;
        }

        this.especificaciones.push({ caracteristica: "", valor: "" });
      });

      this.productoService.getColores(idProduct).subscribe((data) => {
        this.totalCargados++;
        this.coloresSeleccionados = data;
      });

      this.productoService.getArchivos(idProduct).subscribe((data) => {
        this.totalCargados++;
        for (const file of data) {
          file.nombreProducto = this.stringToSlug(this.producto.nombre || "");
          if (file.tipo === this.TYPE_IMG_PRINCIPAL) {
            this.imagenesSeleccionadas.push(new Archivo(file));
          } else if (file.tipo === this.TYPE_IMG_AVATAR) {
            this.imagenesSeleccionadas.unshift(new Archivo(file));
          } else if (
            file.tipo === this.TYPE_IMG_GALLERY ||
            file.tipo === this.TYPE_VIDEO_GALLERY
          ) {
            this.imgGaleriaSeleccionadas.push(new Archivo(file));
          }
        }

        this.imgGaleriaSeleccionadas = _.orderBy(
          this.imgGaleriaSeleccionadas,
          "orden"
        );
      });

      forkJoin([
        this.certificacionesService.get(),
        this.productoService.getCertificaciones(idProduct),
      ]).subscribe((resp) => {
        this.totalCargados++;
        this.certificaciones = resp[0].data;

        for (const certi of resp[1]) {
          const find = _.find(this.certificaciones, { id: certi.id });
          if (find) {
            find.selected = true;
          }
        }
      });

      this.productoService
        .getProductosComplementarios(idProduct)
        .subscribe((data) => {
          this.totalCargados++;
          for (const prod of data) {
            this.prodComplementarios.push(new Producto(prod));
          }
        });

      this.productoService
        .getProductosRelacionados(idProduct)
        .subscribe((data) => {
          this.totalCargados++;
          for (const prod of data) {
            this.prodRelacionados.push(new Producto(prod));
          }
        });

      this.productoService
        .getProductosAlternativos(idProduct)
        .subscribe((data) => {
          this.totalCargados++;
          for (const prod of data) {
            this.prodAlternativos.push(new Producto(prod));
          }
        });

      this.productoService.getCodigos(idProduct).subscribe((resp) => {
        this.totalCargados++;

        _.each(resp, (codigo: CodigoProducto) => {
          this.codigosProducto.push(new CodigoProducto(codigo));
        });
      });

      this.catDocSeleccionadas = [];
      forkJoin([
        this.categoriaDocumentosService.gatAll(this.catDocParams),
        this.productoService.getFichas(idProduct),
      ]).subscribe((resp) => {
        this.totalCargados++;
        for (const iCatDoc of resp[0].data) {
          this.catDocumentos.push(new CategoriaDocumento(iCatDoc));
        }

        for (const iFicha of resp[1].data) {
          const padre = _.find(this.catDocumentos, {
            id: iFicha.categoriaDocumentoId,
          });

          if (padre) {
            this.categoriaDocumentosService.getDocuments(padre.id).subscribe(
              (data) => {
                padre.fichasHijas = [];
                let hijoSel: Documento;
                for (const iDoc of data.data) {
                  const obj = new Documento(iDoc);
                  if (obj.id === iFicha.id) {
                    hijoSel = obj;
                  }
                  padre.fichasHijas.push(obj);
                }

                if (hijoSel) {
                  const auxObj = {
                    categoria: padre,
                    ficha: hijoSel,
                    loader: {
                      hijas: false,
                    },
                  };
                  this.catDocSeleccionadas.push(auxObj);
                }
              },
              (error) => {}
            );
          }
        }
      });

      this.catSeleccionadas = [];
      const estructuraCat: any[] = [];
      const distintIdPadres: any = [];
      forkJoin([
        this.categoriaService.getPadres(),
        this.productoService.getCategorias(idProduct),
      ]).subscribe((resp) => {
        this.totalCargados++;
        for (const o of resp[0]) {
          this.categoriasPadres.push(new Categoria(o));
        }

        const catNormales = _.filter(resp[1], { esFantasia: false });
        _.each(catNormales, (catHija, index) => {
          this.idsCategoriasAntiguas.push(catHija.id);
          const catIntermedia = new Categoria(catHija.categoria);
          const catPadre = _.find(this.categoriasPadres, {
            id: catIntermedia.categoriaId,
          });

          const enEstructura = _.find(distintIdPadres, {
            idPadre: catPadre.id,
          });
          if (enEstructura) {
            if (enEstructura.idsIntermedias.indexOf(catIntermedia.id) === -1) {
              enEstructura.idsIntermedias.push(catIntermedia.id);
            }
          } else {
            distintIdPadres.push({
              idPadre: catPadre.id,
              idsIntermedias: [catIntermedia.id],
            });
          }

          estructuraCat.push({
            catPadreSel: catPadre,
            catIntermediaId: catIntermedia.id,
            catHijaId: catHija.id,
          });
        });

        /**
         * Cargo el arbol de categorias
         */

        for (const elem of distintIdPadres) {
          const parent = _.find(this.categoriasPadres, { id: elem.idPadre });
          this.categoriaService.getHijas(elem.idPadre).subscribe((data) => {
            this.totalCargados++;
            parent.categoriasHijas = data;

            for (const idInter of elem.idsIntermedias) {
              const intermedia = _.find(parent.categoriasHijas, {
                id: idInter,
              });
              this.categoriaService.getHijas(idInter).subscribe((res) => {
                intermedia.categoriasHijas = res;

                const partes = _.filter(estructuraCat, (o) => {
                  if (
                    o.catPadreSel.id === parent.id &&
                    o.catIntermediaId === intermedia.id
                  ) {
                    return o;
                  }
                });

                if (partes) {
                  for (const x of partes) {
                    const catSelHija = _.find(intermedia.categoriasHijas, {
                      id: x.catHijaId,
                    });

                    this.catSeleccionadas.push({
                      catPadreSel: parent,
                      catIntermediaSel: intermedia,
                      catHijaSel: catSelHija,
                      loader: {
                        intermedias: false,
                        hijas: false,
                      },
                    });
                  }
                }
              });
            }
          });
        }
      });
    }
  }

  emparejarOrden(tipo: string) {
    let actuales: Archivo[];
    switch (tipo) {
      case this.bags.imagenes: {
        actuales = this.imagenesSeleccionadas;
        break;
      }
      case this.bags.galeria: {
        actuales = this.imgGaleriaSeleccionadas;
        break;
      }
    }
    _.each(actuales, (o: Archivo, i) => {
      o.orden = i + 1;
      if (tipo === this.bags.imagenes) {
        if (i === 0) {
          o.tipo = this.TYPE_IMG_AVATAR;
        } else {
          o.tipo = this.TYPE_IMG_PRINCIPAL;
        }
      }
    });
  }

  onTextoCompChange(texto: string) {
    this.loaders.prodComp = true;
    this.textoCompChanged.next(texto);
  }

  onTextoRelChange(texto: string) {
    this.loaders.prodRel = true;
    this.textoRelChanged.next(texto);
  }

  onTextoAltChange(texto: string) {
    this.loaders.prodAlt = true;
    this.textoAltChanged.next(texto);
  }

  limpiarTextoComp() {
    this.prodCompBuscados = [];
    this.textoComp = "";
  }

  limpiarTextoRel() {
    this.prodRelBuscados = [];
    this.textoRel = "";
  }

  limpiarTextoAlt() {
    this.prodAltBuscados = [];
    this.textoAlt = "";
  }

  buscarProducto(text: string, tipo: string) {
    let texto = text.replace(new RegExp("span", "ig"), "");
    texto = _.trim(texto);

    if (texto) {
      const objetoBucar: any[] = [{ name: texto }];
      const parametros = { search: JSON.stringify(objetoBucar) };

      if (tipo === "complementarios") {
        this.prodCompBuscados = [];
      } else if (tipo === "relacionados") {
        this.prodRelBuscados = [];
      }

      this.productoService.getPublicados(parametros).subscribe((data) => {
        switch (tipo) {
          case "complementarios":
            this.loaders.prodComp = false;
            for (const pord of data) {
              const indexEncontrado = _.findIndex(this.prodComplementarios, {
                id: pord.id,
              });
              if (indexEncontrado === -1) {
                this.prodCompBuscados.push(new Producto(pord));
              }
            }
            break;
          case "relacionados":
            this.loaders.prodRel = false;
            for (const pord of data) {
              const indexEncontrado = _.findIndex(this.prodRelacionados, {
                id: pord.id,
              });
              if (indexEncontrado === -1) {
                this.prodRelBuscados.push(new Producto(pord));
              }
            }
            break;
          case "alternativos":
            this.loaders.prodAlt = false;
            for (const pord of data) {
              const indexEncontrado = _.findIndex(this.prodAlternativos, {
                id: pord.id,
              });
              if (indexEncontrado === -1) {
                this.prodAltBuscados.push(new Producto(pord));
              }
            }
            break;
          default:
            break;
        }
      });
    } else {
      switch (tipo) {
        case "complementarios":
          this.prodCompBuscados = [];
          this.loaders.prodComp = false;
          break;
        case "relacionados":
          this.prodRelBuscados = [];
          this.loaders.prodRel = false;
          break;
        case "alternativos":
          this.prodAltBuscados = [];
          this.loaders.prodAlt = false;
          break;
        default:
          break;
      }
    }
  }

  agregarProductoComplementario(producto: Producto) {
    this.prodComplementarios.push(producto);
    this.limpiarTextoComp();
  }

  quitarProductoComplementario(index: number) {
    this.prodComplementarios.splice(index, 1);
  }

  agregarProductoRelacionado(producto: Producto) {
    this.prodRelacionados.push(producto);
    this.limpiarTextoRel();
  }

  quitarProductoRelacionado(index: number) {
    this.prodRelacionados.splice(index, 1);
  }

  agregarProductoAlternativo(producto: Producto) {
    this.prodAlternativos.push(producto);
    this.limpiarTextoAlt();
  }

  quitarProductoAlternativo(index: number) {
    this.prodAlternativos.splice(index, 1);
  }

  fileOverBase(e: any, tipo: string): void {
    switch (tipo) {
      case this.bags.imagenes: {
        this.dropZoneOver.imagenes = e;
        break;
      }
      case this.bags.galeria: {
        this.dropZoneOver.galeria = e;
        break;
      }
    }
  }

  publicar() {
    if (this.producto.estado !== DESCONTINUADO) {
      this.producto.estado = PUBLICADO;
    }
  }

  despublicar() {
    if (this.producto.estado !== DESCONTINUADO) {
      this.producto.estado = NO_PUBLICADO;
    }
  }

  descontinuar() {
    this.confirmService
      .confirm("Descontinuar", "¿Seguro que desea descontinuar este Producto?")
      .then((resp) => {
        if (resp) {
          this.producto.estado = DESCONTINUADO;
        }
      });
  }

  cambiarTipoTabla(esVertical: boolean) {
    this.tablaVertical = esVertical;
  }

  quitarArchivo(archivo: Archivo, tipo: string) {
    let borrados: Archivo[];

    switch (tipo) {
      case this.bags.imagenes: {
        _.remove(this.imagenesSeleccionadas, { id: archivo.id });
        borrados = this.imagenesBorradas;
        this.emparejarOrden(tipo);
        break;
      }
      case this.bags.galeria: {
        _.remove(this.imgGaleriaSeleccionadas, { id: archivo.id });
        borrados = this.imgGaleriaBorradas;
        this.emparejarOrden(tipo);
        break;
      }
    }

    if (!archivo.nuevo) {
      borrados.push(archivo);
    }
  }

  cargarArchivo(e: any, tipo: string) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        let tipoArchivo: string;

        switch (tipo) {
          case this.bags.imagenes: {
            this.loaders.imagenes = true;
            tipoArchivo = this.TYPE_IMG_PRINCIPAL;
            break;
          }
          case this.bags.galeria: {
            this.loaders.galeria = true;
            tipoArchivo = this.TYPE_IMG_GALLERY;
            break;
          }
        }

        const newArchivo = new Archivo({
          id: this.contIdsNuevos,
          orden: 0,
          tipo: tipoArchivo,
          nuevo: true,
          nombreProducto: this.stringToSlug(this.producto.nombre),
        });
        newArchivo.file = file;
        this.contIdsNuevos--;

        let name = file.name.replace(/\_/g, " ");
        name = name.replace(/-/g, " ");
        name = name.substring(0, name.lastIndexOf("."));
        newArchivo.nombre = name;

        switch (tipo) {
          case this.bags.imagenes: {
            this.imagenesSeleccionadas.push(newArchivo);
            break;
          }
          case this.bags.galeria: {
            this.imgGaleriaSeleccionadas.push(newArchivo);
            break;
          }
        }
        this.emparejarOrden(tipo);

        this.imageResizeService.resize([file], 500, 200).subscribe((result) => {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            newArchivo.previewUrl = e.target.result;
          };
          reader.readAsDataURL(result);
          switch (tipo) {
            case this.bags.imagenes: {
              this.loaders.imagenes = false;
              break;
            }
            case this.bags.galeria: {
              this.loaders.galeria = false;
              break;
            }
          }
        });
      }
    }
  }

  cargarVideo() {
    if (this.newVideo) {
      if (this.newVideo.indexOf("https://www.youtube.com") >= 0) {
        const newArchivo = new Archivo({
          id: this.contIdsNuevos,
          orden: 0,
          tipo: this.TYPE_VIDEO_GALLERY,
          nuevo: true,
        });
        newArchivo.url = this.newVideo;
        newArchivo.previewUrl = this.newVideo;
        this.contIdsNuevos--;
        this.imgGaleriaSeleccionadas.push(newArchivo);
        this.emparejarOrden(this.bags.galeria);
        this.newVideo = "";
      } else {
        this.toasts.error("Debe ingresar una url de youtube valida.");
        this.newVideo = "";
      }
    }
  }

  colorsChange(value: IColor[]) {
    this.coloresSeleccionados = value;
  }

  selectCertification(certification: ICertificacion) {
    certification.selected = !certification.selected;
  }

  agregarCaracteristica() {
    const find = _.find(this.especificaciones, (o) => {
      if (!o.caracteristica && !o.valor) {
        return o;
      }
    });

    const izquierda = _.find(this.especificaciones, (o) => {
      if (o.caracteristica && !o.valor) {
        return o;
      }
    });

    const derecha = _.find(this.especificaciones, (o) => {
      if (!o.caracteristica && o.valor) {
        return o;
      }
    });

    if (!find && !izquierda && !derecha) {
      this.especificaciones.push({
        caracteristica: "",
        valor: "",
      });
    }
  }

  agregarCaracteristicaSiempre() {
    this.especificaciones.push({
      caracteristica: "",
      valor: "",
      otro: "",
    });
  }

  quitarCaracteristica(index: number) {
    this.especificaciones.splice(index, 1);

    if (this.especificaciones.length === 0) {
      this.especificaciones.push({
        caracteristica: "",
        valor: "",
        otro: "",
      });
    }
  }

  loadDaughterCategories(parent: Categoria, nivel: number, index) {
    if (parent) {
      if (!parent.categoriasHijas || parent.categoriasHijas.length === 0) {
        if (nivel === 1) {
          this.catSeleccionadas[index].loader.intermedias = true;
          this.catSeleccionadas[index].catIntermediaSel = undefined;
        }
        this.catSeleccionadas[index].loader.hijas = true;
        this.catSeleccionadas[index].catHijaSel = undefined;

        this.categoriaService.getHijas(parent.id).subscribe((data) => {
          parent.categoriasHijas = data;
          if (nivel === 1) {
            this.catSeleccionadas[index].loader.intermedias = false;
          }
          this.catSeleccionadas[index].loader.hijas = false;
        });
      } else {
        if (nivel === 1) {
          if (parent.categoriasHijas[0]) {
            this.loadDaughterCategories(
              this.catSeleccionadas[index].catIntermediaSel,
              2,
              index
            );
          } else {
            this.catSeleccionadas[index].loader.hijas = false;
          }
        }
      }
    }
  }

  loadDocuments(categoria: CategoriaDocumento, index) {
    if (categoria) {
      if (!categoria.fichasHijas || categoria.fichasHijas.length === 0) {
        this.catDocSeleccionadas[index].loader.hijas = true;

        this.categoriaDocumentosService.getDocuments(categoria.id).subscribe(
          (data) => {
            categoria.fichasHijas = [];
            for (const iDoc of data.data) {
              categoria.fichasHijas.push(new Documento(iDoc));
            }
            this.catDocSeleccionadas[index].loader.hijas = false;
          },
          (error) => {}
        );
      }
    }
  }

  addCategories() {
    this.catSeleccionadas.push({
      catPadreSel: undefined,
      catIntermediaSel: undefined,
      catHijaSel: undefined,
      loader: {
        intermedias: false,
        hijas: false,
      },
    });
  }

  addDocuments() {
    this.catDocSeleccionadas.push({
      categoria: undefined,
      ficha: undefined,
      loader: {
        hijas: false,
      },
    });
  }

  deelteCategories(index: number) {
    this.catSeleccionadas.splice(index, 1);
  }

  deelteDocument(index: number) {
    this.catDocSeleccionadas.splice(index, 1);
  }

  onError(texto: string) {
    this.loaders.guardar = false;
    this.toasts.error(texto);
  }

  limpiarPantalla(): void {
    this.loaders.guardar = false;
    this.loaders.imagenes = false;
    this.loaders.galeria = false;
    this.loaders.prodComp = false;
    this.loaders.prodRel = false;

    this.dropZoneOver.imagenes = false;
    this.dropZoneOver.galeria = false;

    this.contIdsNuevos = -1;

    this.textoComp = undefined;
    this.textoRel = undefined;
    this.textoAlt = undefined;
    this.prodCompBuscados = [];
    this.prodRelBuscados = [];
    this.prodAltBuscados = [];

    this.prodComplementarios = [];
    this.prodRelacionados = [];
    this.prodAlternativos = [];

    this.producto.detalle = "";
    this.producto.descipcion = "";
    this.producto = new Producto({ orden: 0, esPublicado: true });

    this.imagenesSeleccionadas = [];
    this.imagenesBorradas = [];

    this.imgGaleriaSeleccionadas = [];
    this.imgGaleriaBorradas = [];

    this.coloresSeleccionados = [];

    this.tablaVertical = true;
    this.especificaciones = [
      {
        caracteristica: "",
        valor: "",
        otro: "",
      },
    ];

    this.catSeleccionadas = [
      {
        catPadreSel: undefined,
        catIntermediaSel: undefined,
        catHijaSel: undefined,
        loader: {
          intermedias: false,
          hijas: false,
        },
      },
    ];

    this.catDocSeleccionadas = [
      {
        categoria: undefined,
        ficha: undefined,
        loader: {
          hijas: false,
        },
      },
    ];

    if (this.certificaciones) {
      for (const cer of this.certificaciones) {
        cer.selected = false;
      }
    }
  }

  preview() {
    this.loaders.preview = true;
    this.previewProductService.borrar();
    this.producto.setEspecificaciones(
      this.especificaciones,
      this.tablaVertical
    );
    this.previewProductService.producto = this.producto;
    this.previewProductService.codigos = this.codigosProducto;
    this.previewProductService.colores = this.coloresSeleccionados;
    this.previewProductService.categorias = this.catSeleccionadas;
    this.previewProductService.productosRelacionados = this.prodRelacionados;
    this.previewProductService.productosComplementarios =
      this.prodComplementarios;
    this.previewProductService.productosAlternativos = this.prodAlternativos;
    this.previewProductService.certificaciones = this.certificaciones;
    this.previewProductService.imagenesProducto = this.imagenesSeleccionadas;
    this.previewProductService.archivosGaleria = this.imgGaleriaSeleccionadas;
    this.previewProductService.archivosDescargables = this.catDocSeleccionadas;

    this.router.navigate(["/vista-previa-producto"]);
  }

  eliminar() {
    this.confirmService
      .confirm("Eliminar", "¿Seguro que desea eliminar este Producto?")
      .then((resp) => {
        if (resp) {
          this.loaders.eliminar = true;

          this.productoService.delete(this.producto.id).subscribe(
            (data) => {
              this.toasts.success("Producot eliminado.");
              this.router.navigate([
                "/administrador/admin-sitio/listado-productos",
              ]);
            },
            (error) => {
              this.toasts.error("Problemas al eliminar el Producto.");
              this.loaders.eliminar = false;
            }
          );
        }
      });
  }

  guardarCambios() {
    this.loaders.guardar = true;

    this.producto.setEspecificaciones(
      this.especificaciones,
      this.tablaVertical
    );

    const certiSeleccionadas = _.filter(this.certificaciones, {
      selected: true,
    });

    const categorias = [];
    for (const catSel of this.catSeleccionadas) {
      if (catSel.catHijaSel) {
        categorias.push(catSel.catHijaSel.id);
      }
    }

    const fichas = [];
    for (const fichaSel of this.catDocSeleccionadas) {
      if (fichaSel.ficha) {
        fichas.push(fichaSel.ficha.id);
      }
    }

    if (this.editando) {
      /**
       * Archivos Modificados
       */
      const imgProdModificados = _.filter(this.imagenesSeleccionadas, (o) => {
        if (
          !o.nuevo &&
          (o.orden !== o.antiguoOrden || o.tipo !== o.antiguoTipo)
        ) {
          return o;
        }
      });

      const imgGaleriaModificados = _.filter(
        this.imgGaleriaSeleccionadas,
        (o) => {
          if (!o.nuevo && o.orden !== o.antiguoOrden) {
            return o;
          }
        }
      );

      /**
       * Archivos Nuevos
       */
      const imgProdNuevos = _.filter(this.imagenesSeleccionadas, (o) => {
        if (o.nuevo) {
          return o;
        }
      });
      const imgGaleriaNuevas = _.filter(this.imgGaleriaSeleccionadas, (o) => {
        if (o.nuevo) {
          return o;
        }
      });

      this.productoService
        .edit(this.producto.id, this.producto.getFormData())
        .subscribe(
          (data) => {
            const promEliminarArchivo = [];
            for (const file of this.imagenesBorradas) {
              promEliminarArchivo.push(
                this.productoService.deletaArchivo(this.producto.id, file.id)
              );
            }
            for (const file of this.imgGaleriaBorradas) {
              promEliminarArchivo.push(
                this.productoService.deletaArchivo(this.producto.id, file.id)
              );
            }
            forkJoin(promEliminarArchivo).subscribe(
              null,
              (error) => {
                this.onError("Ocurrió un error al modificar el producto.");
              },
              () => {
                const promModificarArchivo = [];
                for (const file of imgProdModificados) {
                  promModificarArchivo.push(
                    this.productoService.editArchivo(
                      this.producto.id,
                      file.id,
                      file.getFormData()
                    )
                  );
                }
                for (const file of imgGaleriaModificados) {
                  promModificarArchivo.push(
                    this.productoService.editArchivo(
                      this.producto.id,
                      file.id,
                      file.getFormData()
                    )
                  );
                }
                forkJoin(promModificarArchivo).subscribe(
                  null,
                  (error) => {
                    this.onError("Ocurrió un error al modificar el producto.");
                  },
                  () => {
                    const promCrearArchivos = [];
                    for (const file of imgProdNuevos) {
                      promCrearArchivos.push(
                        this.productoService.setArchivo(
                          this.producto.id,
                          file.getFormData()
                        )
                      );
                    }
                    for (const file of imgGaleriaNuevas) {
                      promCrearArchivos.push(
                        this.productoService.setArchivo(
                          this.producto.id,
                          file.getFormData()
                        )
                      );
                    }
                    forkJoin(promCrearArchivos).subscribe(
                      null,
                      (error) => {
                        this.onError(
                          "Ocurrió un error al modificar el producto."
                        );
                      },
                      () => {
                        const idsColores = [];
                        for (const color of this.coloresSeleccionados) {
                          idsColores.push(color.id);
                        }
                        this.productoService
                          .reemplaceColor(this.producto.id, idsColores)
                          .subscribe(
                            (respColor) => {
                              const idsCetifi = [];
                              for (const certi of certiSeleccionadas) {
                                idsCetifi.push(certi.id);
                              }
                              this.productoService
                                .reemplaceCertificados(
                                  this.producto.id,
                                  idsCetifi
                                )
                                .subscribe(
                                  (respCerti) => {
                                    const idsComplementarios = [];
                                    const idsRelacionados = [];
                                    const idsAlternativos = [];
                                    for (const prodCom of this
                                      .prodComplementarios) {
                                      idsComplementarios.push(prodCom.id);
                                    }
                                    for (const prodRel of this
                                      .prodRelacionados) {
                                      idsRelacionados.push(prodRel.id);
                                    }
                                    for (const prodAlt of this
                                      .prodAlternativos) {
                                      idsAlternativos.push(prodAlt.id);
                                    }
                                    forkJoin(
                                      this.productoService.reemplaceProducotosComplementarios(
                                        this.producto.id,
                                        idsComplementarios
                                      ),
                                      this.productoService.reemplaceProducotosRelacionados(
                                        this.producto.id,
                                        idsRelacionados
                                      ),
                                      this.productoService.reemplaceProductosAlternativos(
                                        this.producto.id,
                                        idsAlternativos
                                      ),

                                      this.productoService.reemplaceFichas(
                                        this.producto.id,
                                        fichas
                                      )
                                    ).subscribe(
                                      null,
                                      (error) => {
                                        this.onError(
                                          "Ocurrió un error al modificar el producto."
                                        );
                                      },
                                      () => {
                                        /**
                                         * Categoias a elimar
                                         */

                                        this.productoService
                                          .reemplaceCategories(
                                            this.producto.id,
                                            categorias
                                          )
                                          .subscribe(
                                            null,
                                            (error) => {
                                              this.onError(
                                                "Ocurrió un error al modificar el producto."
                                              );
                                            },
                                            () => {
                                              const idsCodigos = [];
                                              _.each(
                                                this.codigosProducto,
                                                (codigo) => {
                                                  idsCodigos.push(codigo.id);
                                                }
                                              );
                                              this.productoService
                                                .reemplazarCodigos(
                                                  this.producto.id,
                                                  idsCodigos
                                                )
                                                .subscribe(
                                                  (resp) => {
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "product"
                                                      )
                                                      .subscribe();
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "categories/all"
                                                      )
                                                      .subscribe();
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "categories/products"
                                                      )
                                                      .subscribe();
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "categories/menu"
                                                      )
                                                      .subscribe();
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "categories/sidemenu"
                                                      )
                                                      .subscribe();
                                                    this._generalService
                                                      .revalidarPathCache(
                                                        "categories/current"
                                                      )
                                                      .subscribe();
                                                    // loaders.guardar stays true (keeps the Guardar
                                                    // button's spinner up) and the success toast is
                                                    // deferred until here, because especial linking
                                                    // can still be recreating an AI-described category
                                                    // row at this point — showing success/stopping the
                                                    // spinner earlier would be misleading.
                                                    const finalizarGuardado =
                                                      () => {
                                                        this.toasts.success(
                                                          "Producto modificado exitosamente"
                                                        );
                                                        this.loaders.guardar =
                                                          false;
                                                        location.reload();
                                                      };
                                                    this._generalService
                                                      .actualizarProductoEnEspecialDeMarca(
                                                        this.producto.id,
                                                        categorias,
                                                        this.producto.estado
                                                      )
                                                      .subscribe(
                                                        () => {
                                                          this._generalService
                                                            .limpiarProductosDesactualizadosEnEspeciales()
                                                            .subscribe(
                                                              finalizarGuardado,
                                                              finalizarGuardado
                                                            );
                                                        },
                                                        finalizarGuardado
                                                      );
                                                  },
                                                  (error) => {
                                                    this.onError(
                                                      "Ocurrió un error al modificar el producto."
                                                    );
                                                  }
                                                );
                                            }
                                          );
                                      }
                                    );
                                  },
                                  (error) => {
                                    this.onError(
                                      "Ocurrió un error al modificar el producto."
                                    );
                                  }
                                );
                            },
                            (error) => {
                              this.onError(
                                "Ocurrió un error al modificar el producto."
                              );
                            }
                          );
                      }
                    );
                  }
                );
              }
            );
          },
          (error) => {
            this.onError("Ocurrió un error al modificar el producto.");
          }
        );
    } else {
      this.productoService.create(this.producto.getFormData()).subscribe(
        (data) => {
          this.producto.id = data.data.id;

          const promArchivos = [];
          for (let i = 0; i < this.imagenesSeleccionadas.length; i++) {
            promArchivos.push(
              this.productoService.setArchivo(
                this.producto.id,
                this.imagenesSeleccionadas[i].getFormData()
              )
            );
          }
          for (const file of this.imgGaleriaSeleccionadas) {
            promArchivos.push(
              this.productoService.setArchivo(
                this.producto.id,
                file.getFormData()
              )
            );
          }

          forkJoin(promArchivos).subscribe(
            null,
            (error) => {
              this.onError("Ocurrió un error al cargar las imagenes.");
            },
            () => {
              const promColores = [];
              for (const color of this.coloresSeleccionados) {
                promColores.push(
                  this.productoService.setColor(this.producto.id, color.id)
                );
              }
              forkJoin(promColores).subscribe(
                null,
                (error) => {
                  this.onError("Ocurrió un error al asociar los colores.");
                },
                () => {
                  const promCertificados = [];
                  for (const certi of certiSeleccionadas) {
                    promCertificados.push(
                      this.productoService.setCertificado(
                        this.producto.id,
                        certi.id
                      )
                    );
                  }
                  forkJoin(promCertificados).subscribe(
                    null,
                    (error) => {
                      this.onError(
                        "Ocurrió un error al asociar las vertificados."
                      );
                    },
                    () => {
                      const promCategorias = [];
                      for (const idCat of categorias) {
                        const pivot = new CategoriaProducto({
                          orden: 0,
                          productoId: this.producto.id,
                        });
                        promCategorias.push(
                          this.categoriaService.setProducto(
                            idCat,
                            pivot.getFormData()
                          )
                        );
                      }
                      forkJoin(promCategorias).subscribe(
                        null,
                        (error) => {
                          this.onError(
                            "Ocurrió un error al asociar las categorías."
                          );
                        },
                        () => {
                          const idsComplementarios = [];
                          const idsRelacionados = [];
                          const idsAlternativos = [];
                          for (const prodCom of this.prodComplementarios) {
                            idsComplementarios.push(prodCom.id);
                          }
                          for (const prodRel of this.prodRelacionados) {
                            idsRelacionados.push(prodRel.id);
                          }
                          for (const prodAlt of this.prodAlternativos) {
                            idsAlternativos.push(prodAlt.id);
                          }

                          forkJoin(
                            this.productoService.reemplaceProducotosComplementarios(
                              this.producto.id,
                              idsComplementarios
                            ),
                            this.productoService.reemplaceProducotosRelacionados(
                              this.producto.id,
                              idsRelacionados
                            ),
                            this.productoService.reemplaceProductosAlternativos(
                              this.producto.id,
                              idsAlternativos
                            ),
                            this.productoService.reemplaceFichas(
                              this.producto.id,
                              fichas
                            )
                          ).subscribe(
                            null,
                            (error) => {
                              this.onError(
                                "Ocurrió un error al guardar los productos relacionados y completaríos."
                              );
                            },
                            () => {
                              const idsCodigos = [];
                              _.each(this.codigosProducto, (codigo) => {
                                idsCodigos.push(codigo.id);
                              });
                              this.productoService
                                .reemplazarCodigos(this.producto.id, idsCodigos)
                                .subscribe(
                                  (resp) => {
                                    this.limpiarPantalla();
                                    this.toasts.success(
                                      "Producto creado exitosamente"
                                    );
                                  },
                                  (error) => {
                                    this.onError(
                                      "Ocurrió un error al guardar los códigos."
                                    );
                                  }
                                );
                            }
                          );
                        }
                      );
                    }
                  );
                }
              );
            }
          );
        },
        (error) => {
          this.onError("Error al crear el producto.");
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-producto/crear-producto.component.ts